import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import { ThemeProvider } from '@emotion/react';
import { theme } from './app/components/common/theme';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import CssBaseline from '@mui/material/CssBaseline';
import store from './app/store/configureStore';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConfirmProvider } from "material-ui-confirm"

//const msalInstance = new PublicClientApplication(msalConfig);
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <MsalProvider instance={msalInstance}>
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <ConfirmProvider defaultOptions={{
        confirmationButtonProps: { autoFocus: true, variant: "contained", color: "success" },
        cancellationButtonProps: { variant: "contained", color: "error" }
      }}>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
        <CssBaseline />
      </ConfirmProvider>
    </ThemeProvider>
  </Provider>
  // </MsalProvider>
);
